import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-17597c03")

_pushScopeId("data-v-17597c03")
const _hoisted_1 = {
  ref: "chargeableWeightTarget",
  class: "chargeable-weight-summary"
}
const _hoisted_2 = { class: "chargeable-weight-summary__value" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { "data-testid": "adjust-stt-chargeable-weight-value" }
const _hoisted_5 = {
  class: "chargeable-weight-summary__total-koli",
  "data-testid": "txn-booking-label-total-koli"
}
const _hoisted_6 = { class: "chargeable-weight-breakdown__header" }
const _hoisted_7 = { class: "chargeable-weight-breakdown__body" }
const _hoisted_8 = { class: "chargeable-weight-breakdown__details" }
const _hoisted_9 = {
  class: "chargeable-weight-breakdown__row",
  "data-testid": "txn-booking-row-cw-breakdown-totalKoli"
}
const _hoisted_10 = {
  class: "chargeable-weight-breakdown__row",
  "data-testid": "adjust-stt-weight-woodpacking-additional"
}
const _hoisted_11 = {
  class: "chargeable-weight-breakdown__footer",
  "data-testid": "txn-booking-row-cw-breakdown-final"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.formatWeight(_ctx.chargeableWeightKg)) + " kg ", 1),
        _createVNode("button", {
          type: "button",
          class: "chargeable-weight-summary__toggle",
          "data-testid": "txn-booking-toggle-chargeable-weight",
          "aria-expanded": _ctx.chargeableWeightExpanded,
          "aria-controls": "booking-v4-chargeable-weight-breakdown",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onToggleExpand && _ctx.onToggleExpand(...args))),
          onKeydown: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onKeydownTrigger($event)))
        }, [
          _createVNode("img", {
            src: _ctx.chevronIcon,
            alt: _ctx.chargeableWeightExpanded ? 'collapse' : 'expand'
          }, null, 8, ["src", "alt"])
        ], 40, ["aria-expanded"])
      ]),
      _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("bookingV4.totalKoli.format", { n: _ctx.totalKoli })), 1)
    ]),
    _createVNode(_component_OverlayPanel, {
      ref: "chargeableWeightOverlay",
      appendTo: "body",
      baseZIndex: 2000,
      dismissable: false,
      class: "chargeable-weight-breakdown chargeable-weight-overlay",
      "data-testid": "txn-booking-dropdown-cw-breakdown"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_6, _toDisplayString(_ctx.weightDetailTitle), 1),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("span", null, _toDisplayString(_ctx.totalKoliLabel), 1),
              _createVNode("span", null, _toDisplayString(_ctx.totalKoli), 1)
            ]),
            _createVNode("div", {
              class: ["chargeable-weight-breakdown__row", { 'is-dominant': _ctx.isGrossWeightDominant }],
              "data-testid": "txn-booking-row-cw-breakdown-grossWeight"
            }, [
              _createVNode("span", null, _toDisplayString(_ctx.$t("bookingV4.chargeableWeight.grossWeight")), 1),
              _createVNode("span", null, _toDisplayString(_ctx.formatWeight(_ctx.totalGrossWeightKg)) + " kg", 1)
            ], 2),
            _createVNode("div", {
              class: ["chargeable-weight-breakdown__row", {
              'is-dominant': _ctx.isVolumeWeightDominant,
              'is-muted': !_ctx.isVolumeWeightDominant
            }],
              "data-testid": "txn-booking-row-cw-breakdown-volumeWeight"
            }, [
              _createVNode("span", null, _toDisplayString(_ctx.volumeWeightLabel), 1),
              _createVNode("span", null, _toDisplayString(_ctx.formatWeight(_ctx.totalVolumeWeightKg)) + " kg", 1)
            ], 2),
            _createVNode("div", _hoisted_10, [
              _createVNode("span", null, _toDisplayString(_ctx.woodpackingWeightLabel), 1),
              _createVNode("span", null, _toDisplayString(_ctx.formatWeight(_ctx.displayedWoodpackingWeightKg)) + " kg", 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("span", null, _toDisplayString(_ctx.finalWeightLabel), 1),
          _createVNode("span", null, _toDisplayString(_ctx.formatWeight(_ctx.chargeableWeightKg)) + " kg", 1)
        ])
      ]),
      _: 1
    }, 512)
  ], 512))
})